import { Link, useRouterState } from '@tanstack/react-router'
import {
  Activity, FileText, GitBranch, CalendarDays, Clock, Receipt,
  Building2, Users, BarChart2, Settings, X, Sun, Moon, LogOut,
  TrendingUp, Cloud,
} from 'lucide-react'
import { useMsal } from '@azure/msal-react'
import { useUIStore } from '@/stores/uiStore'

const ALL_NAV = [
  { section: 'Modules', items: [
    { to: '/monitoring', label: 'Monitoring',       icon: Activity     },
    { to: '/contracts',  label: 'Contracts',        icon: FileText     },
    { to: '/process',    label: 'Process',          icon: GitBranch    },
    { to: '/planning',   label: 'Project Planning', icon: CalendarDays },
    { to: '/time',       label: 'Time Reporting',   icon: Clock        },
    { to: '/invoicing',  label: 'Invoicing',        icon: Receipt    },
    { to: '/sales',      label: 'Sales',            icon: TrendingUp },
  ]},
  { section: 'Workspace', items: [
    { to: '/customers', label: 'Customers',   icon: Building2 },
    { to: '/projects',  label: 'Projects',    icon: Building2 },
    { to: '/people',    label: 'People',      icon: Users     },
    { to: '/cost',      label: 'Azure Costs', icon: Cloud     },
    { to: '/reports',   label: 'Reports',     icon: BarChart2 },
  ]},
  { section: 'Settings', items: [
    { to: '/settings/integrations', label: 'Integrations', icon: Settings  },
  ]},
]

export default function MobileNavSheet() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const { mobileNavOpen, setMobileNavOpen, theme, toggleTheme } = useUIStore()
  const { instance } = useMsal()
  const isActive = (to: string) => pathname.startsWith(to)

  if (!mobileNavOpen) return null

  return (
    <>
      <div className="mobile-nav-backdrop" onClick={() => setMobileNavOpen(false)} />
      <div className="mobile-nav-sheet">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 12px 12px' }}>
          <svg width="28" height="28" viewBox="0 0 64 64" style={{ display: 'block', borderRadius: 6, flexShrink: 0 }}>
            <rect width="64" height="64" rx="14" fill="var(--ns-text)" />
            <path d="M20 40 L44 40 L40 48 L24 48 Z" fill="var(--ns-brand)" fillOpacity="0.55" />
            <path d="M19 28 L45 28 L41 36 L23 36 Z" fill="var(--ns-brand)" fillOpacity="0.8" />
            <path d="M18 16 L46 16 L42 24 L22 24 Z" fill="var(--ns-brand)" />
          </svg>
          <button className="btn btn-ghost btn-icon" onClick={() => setMobileNavOpen(false)}>
            <X size={16} />
          </button>
        </div>

        {ALL_NAV.map(({ section, items }) => (
          <div key={section}>
            <div className="nav-section-label">{section}</div>
            {items.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className={`nav-item${isActive(to) ? ' active' : ''}`}
                onClick={() => setMobileNavOpen(false)}
              >
                <Icon size={17} className="nav-icon" />
                <span className="nav-label">{label}</span>
              </Link>
            ))}
          </div>
        ))}

        <div style={{ marginTop: 'auto', borderTop: '1px solid var(--ns-border)', padding: '8px 0 16px' }}>
          <button className="nav-item" style={{ width: '100%' }} onClick={toggleTheme}>
            {theme === 'dark' ? <Sun size={17} className="nav-icon" /> : <Moon size={17} className="nav-icon" />}
            <span className="nav-label">{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>
          </button>
          <button
            className="nav-item"
            style={{ width: '100%', color: 'var(--ns-err)' }}
            onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: '/' })}
          >
            <LogOut size={17} className="nav-icon" />
            <span className="nav-label">Sign out</span>
          </button>
        </div>
      </div>
    </>
  )
}
